import styled from 'styled-components';
import logo from '../../../assets/Error-429.svg'

export default function Erro429() {
    return (
        <Container>
            <h4>Parece que você fez muitas requisições.</h4>
            <p>Aguarde um momento e tente novamente.</p>
            <img src={logo} alt="imagem erro 429." />
        </Container>
    );
}

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    
    width: 100%;
    height: 100%;
    
    h4, p{
        color: ${(props) => props.theme.colors.warning};
    }
    
    img {
        width: 40%;
    }
    p{
        font-size: 14px;
    }

    @media (max-width: 700px){
        img{
            width: 90%;
        }
    }
`;